module.exports = __webpack_public_path__ + "img/cardSpecialShow.825459b2.png";